// Handle variant price updates for product cards
document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation to handle dynamically loaded variant selects
  document.addEventListener('change', function(e) {
    if (e.target.matches('select[data-product-id]')) {
      const select = e.target;
      const productId = select.dataset.productId;
      const selectedOption = select.options[select.selectedIndex];
      const price = selectedOption.dataset.price;
      const comparePrice = selectedOption.dataset.comparePrice;
      
      // Update the price display
      const priceContainer = document.getElementById('price-' + productId);
      if (priceContainer) {
        const priceElement = priceContainer.querySelector('.price');
        if (priceElement) {
          // Get currency settings from theme
          const currencyCode = window.Shopify?.currency?.active || 'USD';
          const currencySymbol = window.Shopify?.currency?.symbol || '$';
          
          // Format the price
          const formattedPrice = currencySymbol + (price / 100).toFixed(2);
          
          // Update the price
          const priceSpan = priceElement.querySelector('.amount');
          if (priceSpan) {
            priceSpan.textContent = formattedPrice;
          }
          
          // Update compare at price if it exists
          if (comparePrice && comparePrice !== '') {
            const comparePriceFormatted = currencySymbol + (comparePrice / 100).toFixed(2);
            
            let delElement = priceElement.querySelector('del');
            if (delElement) {
              delElement.querySelector('.amount').textContent = comparePriceFormatted;
            } else {
              // Create compare at price element if it doesn't exist
              const del = document.createElement('del');
              del.innerHTML = '<span class="amount">' + comparePriceFormatted + '</span>';
              priceElement.insertBefore(del, priceElement.querySelector('ins'));
            }
          } else {
            // Remove compare at price if it doesn't exist
            const delElement = priceElement.querySelector('del');
            if (delElement) {
              delElement.remove();
            }
          }
        }
      }
    }
  });
});